import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import axios from "axios";
import AddMenuItem from './../../../modal/Production_Management/Menu_Maker/AddMenuItem';
import AddImport from './../../../modal/Production_Management/Menu_Maker/AddImport';
import EditMenuItem from './../../../modal/Production_Management/Menu_Maker/EditMenuItem';
import ViewMenuMaker from './../../../modal/Production_Management/Menu_Maker/View';
import Feedback from './../../../modal/Production_Management/Menu_Maker/Feedback';
import bgimage from '../../../../images/generate/menu_maker.gif';
import NeededRawMaterial from '../../../modal/Production_Management/Menu_Maker/Needed_RawMaterial';
// import { generateSlidePDF } from './../../../modal/utils/pdfGenerator';

const Mega_Menu = () => {
  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [productCategories, setProductCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [monthFilValue, setMonthFilValue] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  const [calendarWeeks, setCalendarWeeks] = useState([]);
  const [menuByDate, setMenuByDate] = useState({});  
  const [modalType, setModalType] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedDateForModal, setSelectedDateForModal] = useState(null);
  const [selectedSnoForModal, setSelectedSnoForModal] = useState(null);

  const [productOptions, setProductOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showValidation, setShowValidation] = useState(false);
  const [printParams, setPrintParams] = useState(null); // <-- NEW
  const [selectedProductName, setSelectedProductName] = useState("");
  useEffect(() => {
    axios.get(`${baseURL}/products/grouped-by-product-item-category`)
      .then(res => {
        const data = res.data.data || [];
        const opts = [
          { value: 'all', label: 'All Categories' },
          ...data.map(cat => ({
            value: cat.product_category_id.toString(),
            label: cat.product_category_name
          }))
        ];
        setProductCategories(opts);
        if (opts.length) setSelectedCategory(opts[0]);
      })
      .catch(console.error);
  }, [baseURL]);

  useEffect(() => {
    if (!selectedCategory || selectedCategory.value === 'all') {
      setProductOptions([]);
      setSelectedProduct(null);
      return;
    }

    axios.get(`${baseURL}/products/grouped-by-product-item-category`, {
      params: {
        productcategory_id: selectedCategory.value
      }
    })
    .then(res => {
      const filteredCategory = res.data.data?.find(cat => cat.product_category_id.toString() === selectedCategory.value);
      const options = [];

      if (filteredCategory?.products?.length) {
        filteredCategory.products.forEach(product => {
          options.push({
            value: product.product_id,
            label: product.product_name
          });
        });
      }

      setProductOptions(options);
      setSelectedProduct(null);
    })
    .catch(console.error);
  }, [selectedCategory]);


    useEffect(() => {
    if (selectedProduct) {
      const productObj = productOptions.find(p => p.value === selectedProduct);
      setSelectedProductName(productObj ? productObj.label : "");
    }
  }, [selectedProduct, productOptions]);


  const monthYearLabel = monthFilValue?.toDate
    ? monthFilValue.toDate().toLocaleString("default", { month: "long", year: "numeric" })
    : "";

  const getDayStatus = date => {
    const today = new Date();
    const td = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const cd = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    if (cd.getTime() === td.getTime()) return 'current';
    if (cd.getTime() > td.getTime()) return 'future';
    return 'past';
  };

  const generateFullMonthCalendar = (year, month) => {
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const totalDays = lastDay.getDate();
    const firstDayOfWeek = firstDay.getDay();

    const weeks = [];
    let dayCounter = 1;
    let week = new Array(7).fill(null);

    for (let i = firstDayOfWeek; i < 7 && dayCounter <= totalDays; i++) {
      week[i] = { day: dayCounter, date: new Date(year, month, dayCounter) };
      dayCounter++;
    }
    weeks.push(week);

    while (dayCounter <= totalDays) {
      week = new Array(7).fill(null);
      for (let i = 0; i < 7 && dayCounter <= totalDays; i++) {
        week[i] = { day: dayCounter, date: new Date(year, month, dayCounter) };
        dayCounter++;
      }
      weeks.push(week);
    }

    return weeks;
  };

  const handleModalToggle = (type, date, sno = null) => {
    setSelectedDateForModal(date);
    setSelectedSnoForModal(sno);
    setModalType(type);
    setOpen(true);
  };

  const handleProductChange = (option) => {
    setSelectedProduct(option?.value || null);
    setSelectedProductName(option?.label || "");
  };

  const handleGenerate = () => {
    if (!selectedCategory || !monthFilValue || !selectedProduct) {
      setShowValidation(true);
      return;
    }

    setShowMenu(true);
    setMenuByDate({});
    setShowValidation(false);

    const dt = monthFilValue.toDate();
    const params = {
      month: dt.getMonth() + 1, // ✅ Integer (1-12)
      year: dt.getFullYear(),
      productcategory_id: Number(selectedCategory.value),
      product_id: Number(selectedProduct),
      branch_id: branch_id
    };

    console.log("Params sent to API:", params); // ✅ Debug

    setPrintParams(params); // ✅ Used for Print link

    axios
      .get(`${baseURL}/menumaker`, { params }) 
      .then(res => {
        const map = {};
        (res.data.data || []).forEach(item => {
          let parsedItems = [];
          if (typeof item.menumaker_item === 'string') {
            try {
              parsedItems = JSON.parse(item.menumaker_item);
              if (!Array.isArray(parsedItems)) parsedItems = [];
            } catch {
              parsedItems = [];
            }
          } else if (Array.isArray(item.menumaker_item)) {
            parsedItems = item.menumaker_item;
          }

          map[item.menumaker_date] = {
            sno: item.sno,
            items: parsedItems
          };
        });

        setMenuByDate(map);
        setCalendarWeeks(generateFullMonthCalendar(dt.getFullYear(), dt.getMonth()));
      })
      .catch(error => {
        if (error.response) {
          console.error("422 Validation Error:", error.response.data);
          alert("Validation Error: " + JSON.stringify(error.response.data.errors || error.response.data));
        } else {
          console.error("Unexpected Error:", error);
          alert("Unexpected error occurred. Check console.");
        }
      });
  };

  const handleReset = () => {
    setShowMenu(false);
    setMenuByDate({});
    setCalendarWeeks([]);
    setSelectedCategory(null);
    setSelectedProduct(null);
    setMonthFilValue(null);
    setPrintParams(null); // Reset print params
    setShowValidation(false);
  };


  const [holidaysMap, setHolidaysMap] = useState({}); 


  useEffect(() => {
    axios.get(`${baseURL}/holiday/status-zero/active`)
      .then(res => {
        const holidayMap = {};

        res.data.forEach(holiday => {
          const dates = holiday.holiday_dates.split(",");
          dates.forEach(dateStr => {
            holidayMap[dateStr.trim()] = holiday.holiday_reason;
          });
        });

        setHolidaysMap(holidayMap);
      })
      .catch(err => {
        console.error("Failed to fetch holidays", err);
      });
  }, []);

  const handleNeededRawMaterialModal = () => {
        setModalType("NeededRawMaterial");
        setOpen(true);
  };

  const [openMenu, setOpenMenu] = useState(false); // for dropdown 

 
// const handleDownloadPDF = async () => {
//   if (!monthFilValue || !selectedCategory || !selectedProduct) {
//     setShowValidation(true);
//     return;
//   }

//   try {
//     // Handle both cases: selectedProduct is an object or just an ID
//     const productId = typeof selectedProduct === 'object' ? selectedProduct.value : selectedProduct;
//     const productLabel = typeof selectedProduct === 'object' ? selectedProduct.label : `Product ${productId}`;

//     if (!productId) {
//       alert("Please select a valid product");
//       return;
//     }

//     const res = await axios.get(`${baseURL}/manage-products-details/${productId}`);
//     const productData = res.data.data;

//     const totalItemCount = productData.total_item_count || 0;
//     const productName = productData.product_name || productLabel;
//     const categoryName = productData.product_category_name || selectedCategory.label;

//     const selectedDate = new Date(monthFilValue);
//     const month = selectedDate.getMonth() + 1;
//     const year = selectedDate.getFullYear();

//     // Call your PDF generator
//     generateSlidePDF(month, year, categoryName, productName, totalItemCount);

//   } catch (err) {
//     console.error(err);
//     alert("Failed to fetch product details");
//   }
// };

 
// const handleDownloadPDF = async () => {
//   if (!monthFilValue || !selectedCategory || !selectedProduct) {
//     setShowValidation(true);
//     return;
//   }

//   try {
//     // Handle both cases: selectedProduct is an object or just an ID
//     const productId = typeof selectedProduct === 'object' ? selectedProduct.value : selectedProduct;
//     const productLabel = typeof selectedProduct === 'object' ? selectedProduct.label : `Product ${productId}`;

//     if (!productId) {
//       alert("Please select a valid product");
//       return;
//     }

//     // Fetch product details
//     const res = await axios.get(`${baseURL}/manage-products-details/${productId}`);
//     const productData = res.data.data;

//     const productName = productData.product_name || productLabel;
//     const categoryName = productData.product_category_name || selectedCategory.label;
//     const itemDetails = productData.item_details || []; // array of { item_category_name, count }
//     const productColor = productData.product_color || "#34495E"; // fallback color

//     const selectedDate = new Date(monthFilValue);
//     const month = selectedDate.getMonth() + 1;
//     const year = selectedDate.getFullYear();

//     // Call PDF generator, pass productColor for header
//     generateSlidePDF(month, year, categoryName, productName, itemDetails, productColor);

//   } catch (err) {
//     console.error(err);
//     alert("Failed to fetch product details");
//   }
// };

  return (
    <>
      {/* Title & Button */}
      <div className="d-flex justify-content-between page-titles px-0 py-1 mx-0">
        <div className='mb-0'>
          <h4 className='breadcrumb-header'>Menu Maker</h4>
          <ol className="breadcrumb fs-7">
            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item active">Production Management</li>
          </ol>
        </div>

        <div className="d-flex align-items-center gap-2">
        
       

         <Dropdown>
          <Dropdown.Toggle className="btn btn-primary text-white btn-sm">
            <i className="fas fa-concierge-bell me-2"></i>Make Your Menu
          </Dropdown.Toggle>
          <Dropdown.Menu>
            
            <Dropdown.Item 
            // onClick={() => console.log("AI Menu Maker clicked")}
            onClick={() => { setModalType("AddImport"); setOpen(true); }}
            >
              <i className="fas fa-robot me-2 text-success"></i> AI Menu Maker
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown> 
        </div>
      </div>

      {/* Filters */}
      {/* <div className="row mb-3">
        <div className="col-lg-3">
          <label className="text-black font-w500 fs-7">Product Category<span className="required">*</span></label>
          <Select value={selectedCategory} onChange={setSelectedCategory} options={productCategories} placeholder="Select Product Category" />
          {showValidation && !selectedCategory && (
      <span className="text-danger fs-7">This field is required</span>
    )}
        </div>

        <div className="col-lg-3">
          <label className="text-black font-w500 fs-7">Product<span className="required">*</span></label>
            <Select
            placeholder="Select Product"
            options={productOptions}
            onChange={handleProductChange}
            value={productOptions.find(opt => opt.value === selectedProduct) || null}
            isDisabled={!selectedCategory}
          />   
          {showValidation && !selectedProduct && <span className="text-danger fs-7">This Field is Required</span>}
        </div>
 
        <div className="col-lg-3 mb-2">
          <label className="text-black font-w500 fs-7">This Month</label>
          <div className='datepicker-wrapper d-flex'>
            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
            <DatePicker value={monthFilValue} onChange={setMonthFilValue} format="MMM-YYYY" onlyMonthPicker mode="single" calendarPosition="top" />
             
          </div>
          {showValidation && !monthFilValue && (
                <span className="text-danger fs-7">This Field is Required</span>
              )}
        </div>

        <div className="col-lg-2 mt-4 d-flex align-items-center justify-content-start gap-1"> 
          <Button variant="primary" size="sm" onClick={handleGenerate}>Generate</Button>
  
        <Button variant="primary" size="sm" onClick={handleDownloadPDF}>
         <i class="fa fa-download" aria-hidden="true"></i>
        </Button> 

        </div>
      </div> */}

      <div className="row mb-3 align-items-end gx-2">
        <div className="col-auto">
          <label className="text-black font-w500 fs-7">Product Category<span className="required">*</span></label>
          <Select
            value={selectedCategory}
            onChange={setSelectedCategory}
            options={productCategories}
            placeholder="Select Product Category"
            styles={{ container: (base) => ({ ...base, minWidth: 180 }) }}
          />
          {showValidation && !selectedCategory && (
            <span className="text-danger fs-7">This field is required</span>
          )}
        </div>

        <div className="col-auto">
          <label className="text-black font-w500 fs-7">Product<span className="required">*</span></label>
          <Select
            placeholder="Select Product"
            options={productOptions}
            onChange={handleProductChange}
            value={productOptions.find(opt => opt.value === selectedProduct) || null}
            isDisabled={!selectedCategory}
            styles={{ container: (base) => ({ ...base, minWidth: 180 }) }}
          />
          {showValidation && !selectedProduct && (
            <span className="text-danger fs-7">This Field is Required</span>
          )}
        </div>

        <div className="col-auto">
          <label className="text-black font-w500 fs-7">This Month</label>
          <div className='datepicker-wrapper d-flex align-items-center'>
            <div className='input-group-text bg-transparent border-0 px-1'><i className='fa-solid fa-calendar-days fs-4'></i></div>
            <DatePicker
              value={monthFilValue}
              onChange={setMonthFilValue}
              format="MMM-YYYY"
              onlyMonthPicker
              mode="single"
              calendarPosition="top"
            />
          </div>
          {showValidation && !monthFilValue && (
            <span className="text-danger fs-7">This Field is Required</span>
          )}
        </div>

        <div className="col-auto d-flex align-items-center gap-2 mt-4">
          <Button variant="primary" size="sm" onClick={handleGenerate}>
            Generate
          </Button>
        </div>
      </div>

      
      {!showMenu && (
            <div className="container text-center position-relative" style={{ maxWidth: '950px', marginTop: '65px' }}>
                <img src={bgimage} alt="Please select a product and generate"
                    style={{ width: '100%', height: '600px', objectFit: 'cover', borderRadius: '10px' }} />
                <div className="position-absolute top-0 start-50 translate-middle-x"
                    style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        padding: '10px 20px',
                        borderBottomLeftRadius: '8px',
                        borderBottomRightRadius: '8px',
                        marginTop: '20px',
                        maxWidth: '800px',
                        width: '90%'
                    }}>
                    <p className="fs-2 fw-bold text-primary mb-0">
                        With the Menu Maker Calender,Adding Foods and Organizing Your Daily Menu with Atchayapathara Foods!
                    </p>
                </div>
            </div>
      )}
        
      {/* Calendar Table */}
      {showMenu && (
        <div className="row mx-1">
          <div className='col-lg-12 d-flex justify-content-between'>
            <div className='text-red text-center font-w500 fs-2 mb-3'>
              <span>{selectedCategory?.label} </span> - <span>{monthYearLabel}</span>
            </div>
            <div className='d-flex align-items-center'> 
                {printParams && (
                <Link
                  to={`/menu-maker-print?product_id=${printParams.product_id}&month=${printParams.month}&year=${printParams.year}`}

                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary float-end btn-sm"
                >
                  <i className="fa-solid fa-print fs-6 me-2"></i>Print
                </Link>
              )}  
            </div>
          </div>
 
          <table className="tables">
            <thead style={{ backgroundColor: '#1a895e' }}>
              <tr className="text-start text-white fw-bold fs-6">
                {["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map(day => (
                  <th key={day} className='table_custom px-3 py-2'>{day}</th>
                ))}
              </tr>
            </thead>
   


<tbody className="text-gray-600 fw-semibold fs-7">
  {calendarWeeks.map((week, wi) => (
    <tr key={wi}>
      {week.map((dayObj, di) => {
        if (!dayObj) return <td key={di} className="table_custom h-175px w-175px bg-light"></td>;

        const { date } = dayObj;
        const dayStatus = getDayStatus(date);
        const dateKey = date.toLocaleDateString('en-CA'); // YYYY-MM-DD
        const menuEntry = menuByDate[dateKey] || {};
        const meals = Array.isArray(menuEntry.items) ? menuEntry.items : [];
        const sno = menuEntry.sno || null;
        const holidayReason = holidaysMap[dateKey];

       const dayClass = holidayReason
      ? 'border' // ✅ Only border, no background color
      : dayStatus === 'current'
      ? 'bg-info-slight'
      : dayStatus === 'future'
      ? 'bg-success-slight'
      : 'bg-danger-slight';


        return (
          <td key={di} className={`table_custom h-175px w-175px ${dayClass} p-1`}>
            <div className="d-flex flex-column justify-content-between align-items-center w-100 h-100">

              {/* DATE + BUTTONS */}
              <div className='w-100 d-flex justify-content-between align-items-center mb-3'>
                <Badge bg="info" className='py-0 px-1 fs-8'>
                  {String(dayObj.day).padStart(2, '0')}
                </Badge>

                {/* Only show actions if not a holiday */}
                {!holidayReason && dayStatus === 'future' && meals.length > 0 && (
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Edit</Tooltip>}>
                    <Button variant="primary tp-btn-light px-2 py-0 me-1" onClick={() => handleModalToggle("EditMenuItem", date, sno)}>
                      <i className="fa-solid fa-pen-to-square fs-6 mt-1" />
                    </Button>
                  </OverlayTrigger>
                )}

                {!holidayReason && dayStatus === 'past' && (
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Rating</Tooltip>}>
                    <Button variant="tp-btn-light px-2 py-0 me-1" onClick={() => handleModalToggle("Feedback", date)}>
                      <i className="fa fa-star checked fs-6" /><i className="fa fa-star checked fs-6" />
                      <i className="fa fa-star fs-6" /><i className="fa fa-star fs-6" /><i className="fa fa-star fs-6" />
                    </Button>
                  </OverlayTrigger>
                )}
              </div>   

              {/* HOLIDAY ONLY DISPLAY */}
              {holidayReason ? (
                <div className="px-2 mb-3 text-center d-flex justify-content-center align-items-center">
                  <span className="badge bg-danger fs-8 w-100">
                    <i className="fa fa-calendar-day me-1" />{holidayReason}
                  </span>
                </div>
             
              ) : (
                // MEAL DISPLAY (only if not holiday)
                <div className="w-100 text-center mt-auto">
                  {meals.length > 0 ? (
                    <div className='px-2 mb-3 c-pointer' onClick={() => handleModalToggle("View", date, sno)}>
                      <div className='text-black text-start c-pointer'>
                        {meals.slice(0, 4).map((m, idx) => (
                          <div key={idx} className="d-block">
                            <label
                              className="py-1 px-2 fs-8 border text-black badge bg-none c-pointer"
                              title={m.item_name}
                              style={{
                                display: 'inline-block',
                                maxWidth: '120px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {m.item_name}
                            </label>
                          </div>
                        ))}
                        {meals.length > 4 && (
                          <div className='d-block'>
                            <label className='fs-8 text-red fw-bold'>+{meals.length - 4} View</label>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    dayStatus === 'future' && (
                      // <div className="d-flex justify-content-center align-items-center h-100">
                       <div className='px-2 mb-3 text-center d-flex justify-content-center align-items-center'>
                        <OverlayTrigger placement="bottom" overlay={<Tooltip>Add Menu</Tooltip>}>
                          <Button variant="primary tp-btn-light px-2 py-1" onClick={() => handleModalToggle("AddMenuItem", date)}>
                            <i className="fa-regular fa-square-plus fs-1 mt-1" />
                          </Button>
                        </OverlayTrigger>
                      </div>
                    )
                  )}
                </div>
              )}
            </div>
          </td>
        );
      })}
    </tr>
  ))}
</tbody>

</table>

        </div>
      )}

      {/* Modals */}
           {open && modalType === "AddImport" && (
        <AddImport show={open} onClose={() => setOpen(false)} />
      )}
      {/* {open && modalType === "AddImport" && <AddImport show={open} onClose={() => setOpen(false)} />} */}
      {open && modalType === "AddMenuItem" && ( <AddMenuItem show={open} onClose={() => setOpen(false)} selectedDate={selectedDateForModal} selectedCategory={selectedCategory} selectedProduct={selectedProduct} selectedProductName={selectedProductName}  /> )} 
      {open && modalType === "EditMenuItem" && (<EditMenuItem show={open} onClose={() => setOpen(false)} selectedDate={selectedDateForModal} selectedSno={selectedSnoForModal} selectedCategory={selectedCategory} selectedProduct={selectedProduct} selectedProductName={selectedProductName}/> )}
      {open && modalType === "View" && <ViewMenuMaker show={open} onClose={() => setOpen(false)} selectedSno={selectedSnoForModal} selectedCategory={selectedCategory} selectedProduct={selectedProduct} selectedProductName={selectedProductName} />}
      {open && modalType === "Feedback" && <Feedback show={open} onClose={() => setOpen(false)} selectedDate={selectedDateForModal} />}
      {open && modalType === "NeededRawMaterial" && (
          <NeededRawMaterial show={open} onClose={() => setOpen(false)} />
      )}
    </>
  );
};

export default Mega_Menu;
